import { createAction, props } from '@ngrx/store';
import { ITime } from '../../../../model/time';

// Terminals
export const requestTimeDisplay = createAction('[Time Display] Request Time Display');
export const loadTimeDisplay = createAction('[Time Display Effects] Load Time Display', props<{ time: ITime }>());
